import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
// import 'firebase/firestore';
import { LogService } from './log.service';
import { ShareService } from './share.service';
import { doc, Firestore, serverTimestamp, setDoc, updateDoc } from '@angular/fire/firestore';
import { PublicNotesInfo, ShareableItem } from 'globals/store/share.data';

@Injectable({ providedIn: 'root' })
export class ShareNotesService {
  readonly _file = 'share.notes.service.ts'

  constructor(
    private log: LogService,
    public store: Store,
    private shareService: ShareService,
    private db: Firestore,
  ) { }

  async addNewSharedNotes(programId: string, eventId: string, type: 'notes' | 'cues' = 'notes') {
    try {
      const publishCode = await this.shareService.createSlugCode()
      const shareNotes: PublicNotesInfo = { programId, eventId, publishCode, status: 'On' }
      const insertObject: ShareableItem = {
        type,
        code: publishCode,
        info: shareNotes,
        eventId: this.shareService.eventId,
        accountId: this.shareService.accountId,
        timestamp: serverTimestamp()
      }
      await setDoc(doc(this.db, '/shareables/' + publishCode), insertObject)
    } catch (error) {
      this.log.error({
        file:this._file,
        function:'addNewSharedNotes',
        message:'There was an error updating the sharable',
        error
      })
    }
  }

  async changeNotesShareStatus(info: PublicNotesInfo) {
    console.log(info)
    try {
      const response = await updateDoc( doc(this.db, '/shareables/' + info.publishCode), { info })
      this.log.error({ file:this._file, function:'changeNotesShareStatus', message:'There was an error updating the status', data:{ info }, error: new Error(), response} )
    } catch (error) {
      this.log.error({
        file:this._file,
        function:'changeNotesShareStatus',
        message:'There was an error updating the facilitator notes share status',
        error
      })
    }
  }

}